// CSS Imports
import './App.css'

// React-Router Imports
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Pages Imports
import Login from './Login';
import Payment from './Payment';
import YourAnswers from './YourAnswers';
import Thankyou from './Thankyou';
import Thankyou2 from './Thankyou2';
import AdminLogin from './AdminLogin';
import AdminRoute from './components/AdminRoute';
import StaffAccess from './StaffAccess';
/**
 * The staff reports carry a charting library, and a parent re-enrolling on a phone has no use
 * for it. Loaded when a staff member opens the page instead of sitting in the bundle everybody
 * downloads.
 */
const AdminReports = lazy(() => import('./AdminReports'));
const AdminBots = lazy(() => import('./AdminBots'));
const AdminNotReturning = lazy(() => import('./AdminNotReturning'));
const AdminReminders = lazy(() => import('./AdminReminders'));
const AdminFeeSandbox = lazy(() => import('./AdminFeeSandbox'));
const AdminNotReenrolled = lazy(() => import('./AdminNotReenrolled'));
const AdminManualReenrolment = lazy(() => import('./AdminManualReenrolment'));
const AdminReissueConfirmations = lazy(() => import('./AdminReissueConfirmations'));
const AdminPaymentReconciliation = lazy(() => import('./AdminPaymentReconciliation'));
const AdminSettings = lazy(() => import('./AdminSettings'));
import ScrollToTop from './ScrollTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import Reenrolment from './Reenrolment';
import Confirmation from './Confirmation'
import PaymentError from './PaymentError';
import ApproverScreen from './ApproverScreen';
import Introduction from './pages/Introduction';
import RenrolCompleted from './RenrolCompleted';
import BpointPaymentForm from './BpointPaymentForm';
import ParentInformation from './ParentInformation';
import CodeOfConduct from './components/CodeofConduct';
// import ComingSoon from './screens/coming_soon/ComingSoon';
import PaymentResponse from './PaymentResponse';
import ARLogin from './ARLogin';
import ProtectedRoutes from './ProtectedRoutes';

// Azure Imports
// import { msalConfig } from './config';
// import { MsalProvider } from '@azure/msal-react';
// import { PublicClientApplication, EventType } from '@azure/msal-browser';

// const msalInstance = new PublicClientApplication(msalConfig);

// if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//   msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
// }

// msalInstance.addEventCallback(async (event) => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//     const account = await event.payload.account;
//     msalInstance.setActiveAccount(account);
//   }
// })

const App = () => {

  return (
    // process.env.REACT_APP_Reenrolment_Coming_Soon === "true"
    //   ? <ComingSoon />
    //   : <MsalProvider instance={msalInstance}>
    <>
      <ScrollToTop />
      {/* Inside the router, so it can see which screen a family is on. Renders nothing. */}
      <AnalyticsTracker />
      <Suspense fallback={null}>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="/payment" element={<ProtectedRoutes><Payment /></ProtectedRoutes>} />
        <Route path="/your-answers" element={<ProtectedRoutes><YourAnswers /></ProtectedRoutes>} />
        <Route path="/payment-v2" element={<ProtectedRoutes><Payment /></ProtectedRoutes>} />
        <Route path="/thankyou" element={<ProtectedRoutes><Thankyou /></ProtectedRoutes>} />
        <Route path="/thankyou2" element={<ProtectedRoutes><Thankyou2 /></ProtectedRoutes>} />
        <Route path="/thankyou2-v2" element={<ProtectedRoutes><Thankyou2 /></ProtectedRoutes>} />
        <Route path="/arlogin" element={<ARLogin />} />
        <Route path="/reenrolment" element={<ProtectedRoutes><Reenrolment /></ProtectedRoutes>} />
        <Route path="/introduction" element={<ProtectedRoutes><Introduction /></ProtectedRoutes>} />
        <Route path="/confirmation" element={<ProtectedRoutes><Confirmation /></ProtectedRoutes>} />
        <Route path="/paymenterror" element={<ProtectedRoutes><PaymentError /></ProtectedRoutes>} />
        <Route path="/code-of-conduct" element={<ProtectedRoutes><CodeOfConduct /></ProtectedRoutes>} />
        <Route path="/parentinformation" element={<ProtectedRoutes><ParentInformation /></ProtectedRoutes>} />
        <Route path="/paymentresponse" element={<ProtectedRoutes><PaymentResponse /></ProtectedRoutes>} />
        <Route path="/bpointpaymentform" element={<ProtectedRoutes><BpointPaymentForm /></ProtectedRoutes>} />
        <Route path="/bpointpaymentform-v2" element={<ProtectedRoutes><BpointPaymentForm /></ProtectedRoutes>} />
        <Route path="/reenrolmentcompleted" element={<ProtectedRoutes><RenrolCompleted /></ProtectedRoutes>} />
        <Route path="/approver-screen" element={<AdminRoute><ApproverScreen /></AdminRoute>} />
        <Route path="/staff-access" element={<AdminRoute><StaffAccess /></AdminRoute>} />
        <Route path="/admin-settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
        <Route path="/admin-reports" element={<AdminRoute><AdminReports /></AdminRoute>} />
        <Route path="/admin-bots" element={<AdminRoute><AdminBots /></AdminRoute>} />
        <Route path="/admin-not-returning" element={<AdminRoute><AdminNotReturning /></AdminRoute>} />
        <Route path="/admin-reminders" element={<AdminRoute><AdminReminders /></AdminRoute>} />
        <Route path="/admin-fee-sandbox" element={<AdminRoute><AdminFeeSandbox /></AdminRoute>} />
        <Route path="/admin-not-reenrolled" element={<AdminRoute><AdminNotReenrolled /></AdminRoute>} />
        <Route path="/admin-manual-reenrolment" element={<AdminRoute><AdminManualReenrolment /></AdminRoute>} />
        <Route path="/admin-reissue-confirmations" element={<AdminRoute><AdminReissueConfirmations /></AdminRoute>} />
        <Route path="/admin-payment-reconciliation" element={<AdminRoute><AdminPaymentReconciliation /></AdminRoute>} />
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* Anything else goes to the login page. Without this an unknown path — a typo, or
            a stray double slash — renders a blank screen with no clue what went wrong. */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
      </Suspense>
    </>
    // </MsalProvider>
  );
}

export default App;
